import { useLocalObservable } from "mobx-react-lite";
import { createContext, ReactNode, useContext } from "react";

import { SmartTableStore } from "./stores";

// ────────────────────────────────────────────
// Context
// ────────────────────────────────────────────

const SmartTableContext = createContext<SmartTableStore | null>(null);

// ────────────────────────────────────────────
// Provider
// ────────────────────────────────────────────

export const SmartTableProvider = ({ children }: { children: ReactNode }) => {
  const store = useLocalObservable(() => new SmartTableStore());
  return <SmartTableContext.Provider value={store}>{children}</SmartTableContext.Provider>;
};

// ────────────────────────────────────────────
// Hook
// ────────────────────────────────────────────

export const useSmartTableStore = (): SmartTableStore => {
  const store = useContext(SmartTableContext);
  if (!store) {
    throw new Error("useSmartTableStore must be used within a <SmartTableProvider>");
  }
  return store;
};
